export interface HeroSlide {
  id: string;
  title: string;
  summary: string;
  cover: string;
  articleId: string;
  tag: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 'slide-1',
    title: '《乘风破浪的姐姐》第五季巅峰之夜',
    summary: '总决赛舞台全面升级，多个现场片段刷屏社交平台。',
    cover: 'https://readdy.ai/api/search-image?query=grand%20concert%20stage%20with%20vibrant%20orange%20spotlights%20and%20confetti%20falling%2C%20silhouette%20of%20female%20performers%20under%20warm%20dramatic%20lighting%2C%20cinematic%20entertainment%20photography%2C%20rich%20high%20contrast%20warm%20tones&width=1600&height=900&seq=gaoji-hero-1&orientation=landscape',
    articleId: 'variety-001',
    tag: '焦点专题',
  },
  {
    id: 'slide-2',
    title: '《歌手2026》歌王之战：全开麦的极致较量',
    summary: '坚持直播不修音，决赛夜成为歌手与技术团队共同的高压测试。',
    cover: 'https://readdy.ai/api/search-image?query=dramatic%20live%20music%20stage%20with%20single%20singer%20silhouette%20in%20warm%20orange%20spotlight%20and%20swirling%20smoke%2C%20cinematic%20concert%20photography%2C%20high%20contrast%20warm%20tone&width=1600&height=900&seq=gaoji-hero-2&orientation=landscape',
    articleId: 'variety-003',
    tag: '热播综艺',
  },
  {
    id: 'slide-3',
    title: '秋季音乐节阵容陆续官宣',
    summary: '从摇滚到电音，现场经济持续升温，跨城观演成为新常态。',
    cover: 'https://readdy.ai/api/search-image?query=huge%20outdoor%20music%20festival%20crowd%20at%20sunset%20with%20warm%20orange%20stage%20light%20beams%20and%20silhouettes%2C%20energetic%20atmosphere%2C%20cinematic%20wide%20photography&width=1600&height=900&seq=gaoji-hero-3&orientation=landscape',
    articleId: 'news-002',
    tag: '娱乐新闻',
  },
  {
    id: 'slide-4',
    title: '《脱口秀大会》第七季新人来势汹汹',
    summary: '实时投票淘汰赛制让文本质量成为胜负关键，多位素人一战成名。',
    cover: 'https://readdy.ai/api/search-image?query=single%20microphone%20under%20warm%20orange%20spotlight%20on%20empty%20dark%20stage%2C%20stand%20up%20comedy%20atmosphere%2C%20cinematic%20minimal%20photography%2C%20warm%20tone&width=1600&height=900&seq=gaoji-hero-4&orientation=landscape',
    articleId: 'variety-006',
    tag: '趣味内容',
  },
];